export const ROTARY_DIRECTORS_COMMUNITY_TAG = 'rotary-directors-community';

export function communityHasAvenues(platformTags?: readonly string[]): boolean {
  return platformTags?.includes(ROTARY_DIRECTORS_COMMUNITY_TAG) ?? false;
}
